import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useI18n } from 'builder/hooks/useI18n'
import {
  ActionButtonsLeft,
  CloseIcon,
  DashboardButton,
  MenuButton,
  MiddleContainer,
  Wrapper,
} from './styles'
import { Menu } from './Menu/Menu'

interface Props {
  onCloseClick: () => void
  onDashboardClick: () => void
  children?: React.ReactNode
}

export const TRANSLATION_PREFIX = `builder.interview_prep_view.feedbackV2`

export const NavbarWithMenu = ({ onCloseClick, onDashboardClick, children }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const [showSideMenu, setShowSideMenu] = useState(false)
  const navigate = useNavigate()
  const { i18n } = useI18n()

  return (
    <>
      <Wrapper ref={ref}>
        <ActionButtonsLeft>
          <MenuButton onClick={() => setShowSideMenu(prevValue => !prevValue)} />
          <DashboardButton onClick={onDashboardClick}>
            {i18n.t(`${TRANSLATION_PREFIX}.dashboard`)}
          </DashboardButton>
        </ActionButtonsLeft>

        <MiddleContainer>{children} </MiddleContainer>
        <CloseIcon onClick={onCloseClick} />
      </Wrapper>
      {showSideMenu && (
        <Menu
          onClose={() => setShowSideMenu(false)}
          onClick={(path: string) => {
            navigate(path)
          }}
        />
      )}
    </>
  )
}
